import { type VendorProfileDocumentConstructor } from '../../entities/VendorProfileDocument'
import { isRecord } from '../../utils/isRecord'
import { type VendorProfileDocumentApiModel } from '../api-models/VendorProfileDocumentApiModel'

export const mapVendorProfileDocumentApiModel = (
  data: VendorProfileDocumentApiModel
): VendorProfileDocumentConstructor => ({
  uuid: data.uuid,
  source: data.source,
  category: data.category,
  docType: data.doc_type,
  typeName: data.type_name,
  details: isRecord(data.details) ? data.details : {},
  issueDate: data.issue_date ?? null,
  expiryDate: data.expiry_date ?? null,
  originalFilename: data.original_filename,
  uploadedByName: data.uploaded_by_name,
  uploadedAt: data.uploaded_at,
  canDownload: data.can_download,
})
